export const AI_HEALTH_CHECK_URL = 'https://status.openai.com/api/v2/status.json';

export const AVOMD_CONTACT_US = 'https://www.avomd.io/contact-us';
export const AVOMD_PRIVACY_POLICY = 'https://www.avomd.io/privacypolicy';
export const AVOMD_TERMS_OF_USE = 'https://www.avomd.io/termsofuse';
